import { FieldSlugEnum } from 'common/enums/FieldSlugEnum'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { FieldInterface } from 'common/types/entities/field-interface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createContactUsField(
  parentId: string,
  masterBlockId?: MasterBlockId,
  slug?: FieldSlugEnum,
) {
  const field: FieldInterface = {
    id: generateId(),
    optional: false,
    textAlign: 'left',
    type: EntityTypeEnum.ContactUsField,
    parentId: parentId,
    masterBlockId: masterBlockId,
    fontSize: 18,
    slug: FieldSlugEnum.Email,
    backgroundColor: 'rgba(241, 244, 248, 1)',
    padding: {
      paddingTop: 20,
      paddingRight: 10,
      paddingBottom: 20,
      paddingLeft: 10,
    },
    border: {
      radius: 3,
      style: BorderStyleEnum.none,
    },
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 25,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 10,
      marginLeft: 0,
    },
    appearance: {
      desktop: true,
      mobile: true,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.ContactUsField),
  }

  if (slug) {
    field.slug = slug
  }

  return field
}
